import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import DialogLayout from "../../../../partials/content/DialogLayout";
import {
  getItemPackages,
  deleteItemPackage,
} from "../../../../services/sales/itemPackage";
import { formatDate } from "../../../../utils/utils";
import ItemPackageForm from "./itemPackageForm";
import NumberFormat from "react-number-format";
import Illustration from "../../../../partials/content/Illustration";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { Badge } from "react-bootstrap";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function ItemPackageList({ history }) {
  const { reload } = useGlobalData();
  const [itemPackages, setItemPackages] = useState([]);
  const [itemPackageID, setItemPackageID] = useState(0);
  const [openItemPackageForm, setOpenItemPackageForm] = useState(false);
  const [display, setDisplay] = useState(false);
  const [auth, setAuth] = useState({ create: false });
  const itemPackageDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  useEffect(() => {
    getItemPackagesData();
  }, [reload]);
  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/menu");
      },
    },
    {
      title: "New Item Package",
      color: "primary",
      icon: "fas fa-plus-circle",
      onClick: () => {
        setDisplay(false);
        setItemPackageID(0);
        setOpenItemPackageForm(true);
      },
    },
  ];
  return (
    <React.Fragment>
      <PageSubHeader
        title="Item Package List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/item-package/item-package-list",
            title: "Item Packages",
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        {itemPackages.length ? (
          <CustomDataTable
            data={itemPackages}
            dataDetailColumns={itemPackageDetailColumn}
            onRefreshData={() => {
              getItemPackagesData();
            }}
            tableName="itemPackage"
            selectionMode="checkbox"
            columns={[
              {
                selectionMode: "multiple",
              },
              {
                header: "Package ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Package Code",
                field: "packageCode",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.packageCode}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Package Name",
                field: "packageName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.packageName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Start Date",
                field: "startDate",
                body: (rowData) => formatDate(rowData.startDate),
                sortable: true,
                filter: true,
              },
              {
                header: "End Date",
                field: "endDate",
                body: (rowData) => formatDate(rowData.endDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Package Status",
                field: "packageStatus",
                body: (rowData) => {
                  if (rowData.packageStatus === 2) {
                    return (
                      <Badge variant="danger">
                        {rowData.packageStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.packageStatus === 1) {
                    return (
                      <Badge variant="success">
                        {rowData.packageStatusDesc}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.packageStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Package Price",
                field: "price",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.price}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Edit Item Package">
                      <button
                        type="button"
                        onClick={(event) => {
                          setDisplay(false);
                          setItemPackageID(rowData.ID);
                          setOpenItemPackageForm(true);
                        }}
                        className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Item Package Detail">
                      <button
                        type="button"
                        onClick={(event) => {
                          setDisplay(true);
                          setItemPackageID(rowData.ID);
                          setOpenItemPackageForm(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Delete Item Package">
                      <button
                        type="button"
                        onClick={() => deleteItemPackageData(rowData.ID)}
                        className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        ) : (
          <Illustration
            imageSource="INVIFO Sales.png"
            description="Hooray! You're ready to have your first Item Package!"
            guidance='Hint: setup the sale item packages such as "New Year Package", "Holiday Package", etc.'
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
      <DialogLayout
        open={openItemPackageForm}
        title="Item Package Form"
        onCloseDialog={() => {
          setOpenItemPackageForm(false);
        }}
        maxWIdth="md"
      >
        <ItemPackageForm
          displayOnly={display}
          itemPackageID={itemPackageID}
          onCloseDialog={() => {
            setOpenItemPackageForm(false);
          }}
          onConfirmSave={() => {
            getItemPackagesData();
            setOpenItemPackageForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  async function deleteItemPackageData(itemPackageID) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Item Package ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteItemPackage(itemPackageID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getItemPackagesData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getItemPackagesData() {
    const response = await getItemPackages();
    const { data, auth } = response.data;
    setItemPackages(data.itemPackages);
    setAuth(auth);
  }
}

export default ItemPackageList;
